import { Controller } from "stimulus";

const ACTIVE_SHADOW = "inset 3px 0 0 0 #2684ff";

export default class extends Controller {
  static targets = ["link", "pane"];

  connect() {
    this.linkTargets.forEach((link) => {
      if (link.classList.contains("active")) this.highlight(link);
    });
  }

  select(event) {
    event.preventDefault();
    const link = event.currentTarget;

    this.linkTargets.forEach((other) => {
      other.classList.remove("active");
      const row = other.closest(".list-group-item");
      if (row) row.style.boxShadow = "";
    });
    this.paneTargets.forEach((pane) => pane.classList.remove("show", "active"));

    link.classList.add("active");
    this.highlight(link);

    const targetId = link.getAttribute("href").substring(1);
    const target = this.paneTargets.find((pane) => pane.id === targetId);
    if (target) target.classList.add("show", "active");
  }

  highlight(link) {
    const row = link.closest(".list-group-item");
    if (row) row.style.boxShadow = ACTIVE_SHADOW;
  }
}
